
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.4.2
 * Query Engine version: ac9d7041ed77bcc8a8dbd2ab6616b39013829574
 */
Prisma.prismaVersion = {
  client: "5.4.2",
  engine: "ac9d7041ed77bcc8a8dbd2ab6616b39013829574"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.HostScalarFieldEnum = {
  userId: 'userId',
  eventTypeId: 'eventTypeId',
  isFixed: 'isFixed'
};

exports.Prisma.EventTypeScalarFieldEnum = {
  id: 'id',
  title: 'title',
  slug: 'slug',
  description: 'description',
  position: 'position',
  locations: 'locations',
  length: 'length',
  offsetStart: 'offsetStart',
  hidden: 'hidden',
  userId: 'userId',
  teamId: 'teamId',
  eventName: 'eventName',
  parentId: 'parentId',
  bookingFields: 'bookingFields',
  timeZone: 'timeZone',
  periodType: 'periodType',
  periodStartDate: 'periodStartDate',
  periodEndDate: 'periodEndDate',
  periodDays: 'periodDays',
  periodCountCalendarDays: 'periodCountCalendarDays',
  lockTimeZoneToggleOnBookingPage: 'lockTimeZoneToggleOnBookingPage',
  requiresConfirmation: 'requiresConfirmation',
  requiresBookerEmailVerification: 'requiresBookerEmailVerification',
  recurringEvent: 'recurringEvent',
  disableGuests: 'disableGuests',
  hideCalendarNotes: 'hideCalendarNotes',
  minimumBookingNotice: 'minimumBookingNotice',
  beforeEventBuffer: 'beforeEventBuffer',
  afterEventBuffer: 'afterEventBuffer',
  seatsPerTimeSlot: 'seatsPerTimeSlot',
  seatsShowAttendees: 'seatsShowAttendees',
  seatsShowAvailabilityCount: 'seatsShowAvailabilityCount',
  schedulingType: 'schedulingType',
  scheduleId: 'scheduleId',
  price: 'price',
  currency: 'currency',
  slotInterval: 'slotInterval',
  metadata: 'metadata',
  successRedirectUrl: 'successRedirectUrl',
  bookingLimits: 'bookingLimits',
  durationLimits: 'durationLimits'
};

exports.Prisma.CredentialScalarFieldEnum = {
  id: 'id',
  type: 'type',
  key: 'key',
  userId: 'userId',
  teamId: 'teamId',
  appId: 'appId',
  subscriptionId: 'subscriptionId',
  paymentStatus: 'paymentStatus',
  billingCycleStart: 'billingCycleStart',
  invalid: 'invalid'
};

exports.Prisma.DestinationCalendarScalarFieldEnum = {
  id: 'id',
  integration: 'integration',
  externalId: 'externalId',
  userId: 'userId',
  eventTypeId: 'eventTypeId',
  credentialId: 'credentialId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  username: 'username',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  password: 'password',
  bio: 'bio',
  avatar: 'avatar',
  avatarUrl: 'avatarUrl',
  timeZone: 'timeZone',
  weekStart: 'weekStart',
  startTime: 'startTime',
  endTime: 'endTime',
  bufferTime: 'bufferTime',
  hideBranding: 'hideBranding',
  theme: 'theme',
  createdDate: 'createdDate',
  trialEndsAt: 'trialEndsAt',
  defaultScheduleId: 'defaultScheduleId',
  completedOnboarding: 'completedOnboarding',
  locale: 'locale',
  timeFormat: 'timeFormat',
  twoFactorSecret: 'twoFactorSecret',
  twoFactorEnabled: 'twoFactorEnabled',
  backupCodes: 'backupCodes',
  identityProvider: 'identityProvider',
  identityProviderId: 'identityProviderId',
  invitedTo: 'invitedTo',
  brandColor: 'brandColor',
  darkBrandColor: 'darkBrandColor',
  away: 'away',
  allowDynamicBooking: 'allowDynamicBooking',
  allowSEOIndexing: 'allowSEOIndexing',
  receiveMonthlyDigestEmail: 'receiveMonthlyDigestEmail',
  metadata: 'metadata',
  verified: 'verified',
  role: 'role',
  disableImpersonation: 'disableImpersonation',
  organizationId: 'organizationId',
  locked: 'locked'
};

exports.Prisma.TeamScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  logo: 'logo',
  logoUrl: 'logoUrl',
  appLogo: 'appLogo',
  appIconLogo: 'appIconLogo',
  bio: 'bio',
  hideBranding: 'hideBranding',
  isPrivate: 'isPrivate',
  hideBookATeamMember: 'hideBookATeamMember',
  createdAt: 'createdAt',
  metadata: 'metadata',
  theme: 'theme',
  brandColor: 'brandColor',
  darkBrandColor: 'darkBrandColor',
  parentId: 'parentId',
  timeFormat: 'timeFormat',
  timeZone: 'timeZone',
  weekStart: 'weekStart'
};

exports.Prisma.MembershipScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  userId: 'userId',
  accepted: 'accepted',
  role: 'role',
  disableImpersonation: 'disableImpersonation'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  token: 'token',
  expires: 'expires',
  expiresInDays: 'expiresInDays',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  teamId: 'teamId'
};

exports.Prisma.BookingReferenceScalarFieldEnum = {
  id: 'id',
  type: 'type',
  uid: 'uid',
  meetingId: 'meetingId',
  meetingPassword: 'meetingPassword',
  meetingUrl: 'meetingUrl',
  bookingId: 'bookingId',
  externalCalendarId: 'externalCalendarId',
  deleted: 'deleted',
  credentialId: 'credentialId'
};

exports.Prisma.AttendeeScalarFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  timeZone: 'timeZone',
  locale: 'locale',
  bookingId: 'bookingId'
};

exports.Prisma.BookingScalarFieldEnum = {
  id: 'id',
  uid: 'uid',
  userId: 'userId',
  eventTypeId: 'eventTypeId',
  title: 'title',
  description: 'description',
  customInputs: 'customInputs',
  responses: 'responses',
  startTime: 'startTime',
  endTime: 'endTime',
  location: 'location',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  paid: 'paid',
  destinationCalendarId: 'destinationCalendarId',
  cancellationReason: 'cancellationReason',
  rejectionReason: 'rejectionReason',
  dynamicEventSlugRef: 'dynamicEventSlugRef',
  dynamicGroupSlugRef: 'dynamicGroupSlugRef',
  rescheduled: 'rescheduled',
  fromReschedule: 'fromReschedule',
  recurringEventId: 'recurringEventId',
  smsReminderNumber: 'smsReminderNumber',
  scheduledJobs: 'scheduledJobs',
  metadata: 'metadata',
  isRecorded: 'isRecorded'
};

exports.Prisma.ScheduleScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  timeZone: 'timeZone'
};

exports.Prisma.AvailabilityScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  eventTypeId: 'eventTypeId',
  days: 'days',
  startTime: 'startTime',
  endTime: 'endTime',
  date: 'date',
  scheduleId: 'scheduleId'
};

exports.Prisma.SelectedCalendarScalarFieldEnum = {
  userId: 'userId',
  integration: 'integration',
  externalId: 'externalId',
  credentialId: 'credentialId'
};

exports.Prisma.EventTypeCustomInputScalarFieldEnum = {
  id: 'id',
  eventTypeId: 'eventTypeId',
  label: 'label',
  type: 'type',
  options: 'options',
  required: 'required',
  placeholder: 'placeholder'
};

exports.Prisma.ResetPasswordRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  expires: 'expires'
};

exports.Prisma.ReminderMailScalarFieldEnum = {
  id: 'id',
  referenceId: 'referenceId',
  reminderType: 'reminderType',
  elapsedMinutes: 'elapsedMinutes',
  createdAt: 'createdAt'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  uid: 'uid',
  appId: 'appId',
  bookingId: 'bookingId',
  amount: 'amount',
  fee: 'fee',
  currency: 'currency',
  success: 'success',
  refunded: 'refunded',
  data: 'data',
  externalId: 'externalId',
  paymentOption: 'paymentOption'
};

exports.Prisma.WebhookScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  teamId: 'teamId',
  eventTypeId: 'eventTypeId',
  subscriberUrl: 'subscriberUrl',
  payloadTemplate: 'payloadTemplate',
  createdAt: 'createdAt',
  active: 'active',
  eventTriggers: 'eventTriggers',
  appId: 'appId',
  secret: 'secret'
};

exports.Prisma.ImpersonationsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  impersonatedUserId: 'impersonatedUserId',
  impersonatedById: 'impersonatedById'
};

exports.Prisma.ApiKeyScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  teamId: 'teamId',
  note: 'note',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  lastUsedAt: 'lastUsedAt',
  hashedKey: 'hashedKey',
  appId: 'appId'
};

exports.Prisma.HashedLinkScalarFieldEnum = {
  id: 'id',
  link: 'link',
  eventTypeId: 'eventTypeId'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.AppScalarFieldEnum = {
  slug: 'slug',
  dirName: 'dirName',
  keys: 'keys',
  categories: 'categories',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabled: 'enabled'
};

exports.Prisma.App_RoutingForms_FormScalarFieldEnum = {
  id: 'id',
  description: 'description',
  position: 'position',
  routes: 'routes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  fields: 'fields',
  userId: 'userId',
  teamId: 'teamId',
  disabled: 'disabled',
  settings: 'settings'
};

exports.Prisma.App_RoutingForms_FormResponseScalarFieldEnum = {
  id: 'id',
  formFillerId: 'formFillerId',
  formId: 'formId',
  response: 'response',
  createdAt: 'createdAt'
};

exports.Prisma.FeedbackScalarFieldEnum = {
  id: 'id',
  date: 'date',
  userId: 'userId',
  rating: 'rating',
  comment: 'comment'
};

exports.Prisma.WorkflowStepScalarFieldEnum = {
  id: 'id',
  stepNumber: 'stepNumber',
  action: 'action',
  workflowId: 'workflowId',
  sendTo: 'sendTo',
  reminderBody: 'reminderBody',
  emailSubject: 'emailSubject',
  template: 'template',
  numberRequired: 'numberRequired',
  sender: 'sender',
  numberVerificationPending: 'numberVerificationPending',
  includeCalendarEvent: 'includeCalendarEvent'
};

exports.Prisma.WorkflowScalarFieldEnum = {
  id: 'id',
  position: 'position',
  name: 'name',
  userId: 'userId',
  teamId: 'teamId',
  trigger: 'trigger',
  time: 'time',
  timeUnit: 'timeUnit'
};

exports.Prisma.WorkflowsOnEventTypesScalarFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  eventTypeId: 'eventTypeId'
};

exports.Prisma.DeploymentScalarFieldEnum = {
  id: 'id',
  logo: 'logo',
  theme: 'theme',
  licenseKey: 'licenseKey',
  agreedLicenseAt: 'agreedLicenseAt'
};

exports.Prisma.WorkflowReminderScalarFieldEnum = {
  id: 'id',
  bookingUid: 'bookingUid',
  method: 'method',
  scheduledDate: 'scheduledDate',
  referenceId: 'referenceId',
  scheduled: 'scheduled',
  workflowStepId: 'workflowStepId',
  cancelled: 'cancelled',
  seatReferenceId: 'seatReferenceId'
};

exports.Prisma.WebhookScheduledTriggersScalarFieldEnum = {
  id: 'id',
  jobName: 'jobName',
  subscriberUrl: 'subscriberUrl',
  payload: 'payload',
  startAfter: 'startAfter',
  retryCount: 'retryCount',
  createdAt: 'createdAt'
};

exports.Prisma.BookingSeatScalarFieldEnum = {
  id: 'id',
  referenceUid: 'referenceUid',
  bookingId: 'bookingId',
  attendeeId: 'attendeeId',
  data: 'data'
};

exports.Prisma.VerifiedNumberScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  teamId: 'teamId',
  phoneNumber: 'phoneNumber'
};

exports.Prisma.FeatureScalarFieldEnum = {
  slug: 'slug',
  enabled: 'enabled',
  description: 'description',
  type: 'type',
  stale: 'stale',
  lastUsedAt: 'lastUsedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SelectedSlotsScalarFieldEnum = {
  id: 'id',
  eventTypeId: 'eventTypeId',
  userId: 'userId',
  slotUtcStartDate: 'slotUtcStartDate',
  slotUtcEndDate: 'slotUtcEndDate',
  uid: 'uid',
  releaseAt: 'releaseAt',
  isSeat: 'isSeat'
};

exports.Prisma.OAuthClientScalarFieldEnum = {
  clientId: 'clientId',
  redirectUri: 'redirectUri',
  clientSecret: 'clientSecret',
  name: 'name',
  logo: 'logo'
};

exports.Prisma.AccessCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  clientId: 'clientId',
  expiresAt: 'expiresAt',
  scopes: 'scopes',
  userId: 'userId',
  teamId: 'teamId'
};

exports.Prisma.CalendarCacheScalarFieldEnum = {
  key: 'key',
  value: 'value',
  expiresAt: 'expiresAt',
  credentialId: 'credentialId'
};

exports.Prisma.TempOrgRedirectScalarFieldEnum = {
  id: 'id',
  from: 'from',
  fromOrgId: 'fromOrgId',
  type: 'type',
  toUrl: 'toUrl',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AvatarScalarFieldEnum = {
  teamId: 'teamId',
  userId: 'userId',
  data: 'data',
  objectKey: 'objectKey'
};

exports.Prisma.BookingTimeStatusScalarFieldEnum = {
  id: 'id',
  uid: 'uid',
  eventTypeId: 'eventTypeId',
  title: 'title',
  description: 'description',
  startTime: 'startTime',
  endTime: 'endTime',
  createdAt: 'createdAt',
  location: 'location',
  paid: 'paid',
  status: 'status',
  rescheduled: 'rescheduled',
  userId: 'userId',
  teamId: 'teamId',
  eventLength: 'eventLength',
  timeStatus: 'timeStatus',
  eventParentId: 'eventParentId',
  userEmail: 'userEmail',
  username: 'username'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.PeriodType = exports.$Enums.PeriodType = {
  UNLIMITED: 'UNLIMITED',
  ROLLING: 'ROLLING',
  RANGE: 'RANGE'
};

exports.SchedulingType = exports.$Enums.SchedulingType = {
  ROUND_ROBIN: 'ROUND_ROBIN',
  COLLECTIVE: 'COLLECTIVE',
  MANAGED: 'MANAGED'
};

exports.IdentityProvider = exports.$Enums.IdentityProvider = {
  CAL: 'CAL',
  GOOGLE: 'GOOGLE',
  SAML: 'SAML'
};

exports.UserPermissionRole = exports.$Enums.UserPermissionRole = {
  USER: 'USER',
  ADMIN: 'ADMIN'
};

exports.MembershipRole = exports.$Enums.MembershipRole = {
  MEMBER: 'MEMBER',
  ADMIN: 'ADMIN',
  OWNER: 'OWNER'
};

exports.BookingStatus = exports.$Enums.BookingStatus = {
  CANCELLED: 'CANCELLED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING'
};

exports.EventTypeCustomInputType = exports.$Enums.EventTypeCustomInputType = {
  TEXT: 'TEXT',
  TEXTLONG: 'TEXTLONG',
  NUMBER: 'NUMBER',
  BOOL: 'BOOL',
  RADIO: 'RADIO',
  PHONE: 'PHONE'
};

exports.ReminderType = exports.$Enums.ReminderType = {
  PENDING_BOOKING_CONFIRMATION: 'PENDING_BOOKING_CONFIRMATION'
};

exports.PaymentOption = exports.$Enums.PaymentOption = {
  ON_BOOKING: 'ON_BOOKING',
  HOLD: 'HOLD'
};

exports.WebhookTriggerEvents = exports.$Enums.WebhookTriggerEvents = {
  BOOKING_CREATED: 'BOOKING_CREATED',
  BOOKING_PAYMENT_INITIATED: 'BOOKING_PAYMENT_INITIATED',
  BOOKING_PAID: 'BOOKING_PAID',
  BOOKING_RESCHEDULED: 'BOOKING_RESCHEDULED',
  BOOKING_REQUESTED: 'BOOKING_REQUESTED',
  BOOKING_CANCELLED: 'BOOKING_CANCELLED',
  BOOKING_REJECTED: 'BOOKING_REJECTED',
  FORM_SUBMITTED: 'FORM_SUBMITTED',
  MEETING_ENDED: 'MEETING_ENDED',
  RECORDING_READY: 'RECORDING_READY'
};

exports.AppCategories = exports.$Enums.AppCategories = {
  calendar: 'calendar',
  messaging: 'messaging',
  other: 'other',
  payment: 'payment',
  video: 'video',
  web3: 'web3',
  automation: 'automation',
  analytics: 'analytics',
  conferencing: 'conferencing',
  crm: 'crm'
};

exports.WorkflowActions = exports.$Enums.WorkflowActions = {
  EMAIL_HOST: 'EMAIL_HOST',
  EMAIL_ATTENDEE: 'EMAIL_ATTENDEE',
  SMS_ATTENDEE: 'SMS_ATTENDEE',
  SMS_NUMBER: 'SMS_NUMBER',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  WHATSAPP_ATTENDEE: 'WHATSAPP_ATTENDEE',
  WHATSAPP_NUMBER: 'WHATSAPP_NUMBER'
};

exports.WorkflowTemplates = exports.$Enums.WorkflowTemplates = {
  REMINDER: 'REMINDER',
  CUSTOM: 'CUSTOM',
  CANCELLED: 'CANCELLED',
  RESCHEDULED: 'RESCHEDULED',
  COMPLETED: 'COMPLETED'
};

exports.WorkflowTriggerEvents = exports.$Enums.WorkflowTriggerEvents = {
  BEFORE_EVENT: 'BEFORE_EVENT',
  EVENT_CANCELLED: 'EVENT_CANCELLED',
  NEW_EVENT: 'NEW_EVENT',
  AFTER_EVENT: 'AFTER_EVENT',
  RESCHEDULE_EVENT: 'RESCHEDULE_EVENT'
};

exports.TimeUnit = exports.$Enums.TimeUnit = {
  DAY: 'DAY',
  HOUR: 'HOUR',
  MINUTE: 'MINUTE'
};

exports.WorkflowMethods = exports.$Enums.WorkflowMethods = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP'
};

exports.FeatureType = exports.$Enums.FeatureType = {
  RELEASE: 'RELEASE',
  EXPERIMENT: 'EXPERIMENT',
  OPERATIONAL: 'OPERATIONAL',
  KILL_SWITCH: 'KILL_SWITCH',
  PERMISSION: 'PERMISSION'
};

exports.AccessScope = exports.$Enums.AccessScope = {
  READ_BOOKING: 'READ_BOOKING',
  READ_PROFILE: 'READ_PROFILE'
};

exports.RedirectType = exports.$Enums.RedirectType = {
  UserEventType: 'UserEventType',
  TeamEventType: 'TeamEventType',
  User: 'User',
  Team: 'Team'
};

exports.Prisma.ModelName = {
  Host: 'Host',
  EventType: 'EventType',
  Credential: 'Credential',
  DestinationCalendar: 'DestinationCalendar',
  User: 'User',
  Team: 'Team',
  Membership: 'Membership',
  VerificationToken: 'VerificationToken',
  BookingReference: 'BookingReference',
  Attendee: 'Attendee',
  Booking: 'Booking',
  Schedule: 'Schedule',
  Availability: 'Availability',
  SelectedCalendar: 'SelectedCalendar',
  EventTypeCustomInput: 'EventTypeCustomInput',
  ResetPasswordRequest: 'ResetPasswordRequest',
  ReminderMail: 'ReminderMail',
  Payment: 'Payment',
  Webhook: 'Webhook',
  Impersonations: 'Impersonations',
  ApiKey: 'ApiKey',
  HashedLink: 'HashedLink',
  Account: 'Account',
  Session: 'Session',
  App: 'App',
  App_RoutingForms_Form: 'App_RoutingForms_Form',
  App_RoutingForms_FormResponse: 'App_RoutingForms_FormResponse',
  Feedback: 'Feedback',
  WorkflowStep: 'WorkflowStep',
  Workflow: 'Workflow',
  WorkflowsOnEventTypes: 'WorkflowsOnEventTypes',
  Deployment: 'Deployment',
  WorkflowReminder: 'WorkflowReminder',
  WebhookScheduledTriggers: 'WebhookScheduledTriggers',
  BookingSeat: 'BookingSeat',
  VerifiedNumber: 'VerifiedNumber',
  Feature: 'Feature',
  SelectedSlots: 'SelectedSlots',
  OAuthClient: 'OAuthClient',
  AccessCode: 'AccessCode',
  CalendarCache: 'CalendarCache',
  TempOrgRedirect: 'TempOrgRedirect',
  Avatar: 'Avatar',
  BookingTimeStatus: 'BookingTimeStatus'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
